import { v4 as uuidv4 } from 'uuid';

//helper for generating uuid
var generateUUID = function generateUUID() {
  var uuid = uuidv4();
  return uuid;
};
export default generateUUID;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/generateUUID.js
// module id = 2309
// module chunks = 11